/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Phonenumber1Inputs */

const en__field_phonenumber1 = /** @type {(inputs: _Field_Phonenumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone Number`)
};

const de__field_phonenumber1 = /** @type {(inputs: _Field_Phonenumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handynummer`)
};

/**
* | output |
* | --- |
* | "Phone Number" |
*
* @param {_Field_Phonenumber1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_phonenumber1 = /** @type {((inputs?: _Field_Phonenumber1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Phonenumber1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_phonenumber1(inputs)
	return de__field_phonenumber1(inputs)
});
export { _field_phonenumber1 as "_field_phoneNumber" }